import { isRecord } from '@openx/components-core/lib/Markdown/widgets/answerWidgetPayload.ts';
import type { ConstValues } from '@openx/types/helpers.ts';

export const OpenXAgentWidgetKind = {
  TARGETING_CHIPS: 'targetingChips',
  PERSONAS: 'personas',
} as const;

export type OpenXAgentWidgetKind = ConstValues<typeof OpenXAgentWidgetKind>;

// this is subject to change if needed for the API contracts
export const getOpenXAgentWidgetKind = (payload: unknown): OpenXAgentWidgetKind | null => {
  if (!isRecord(payload)) return null;
  if ('groups' in payload) return OpenXAgentWidgetKind.TARGETING_CHIPS;
  if ('personas' in payload) return OpenXAgentWidgetKind.PERSONAS;
  return null;
};
